<template>
    <div
        :class="{
            'cash-con': true,
            dark: !isLight,
            light: isLight,
        }"
    >
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <loading />
    </div>
</template>

<script>
import { ThemeWatcher } from '@/utils/theme'

export default {
    data() {
        return {
            isLight: ThemeWatcher.isLight(),
            themeWatcher: null,
        }
    },
    computed: {},
    mounted() {
        // 创建主题监听器
        this.themeWatcher = new ThemeWatcher()
        this.themeWatcher.watch(() => {
            this.isLight = ThemeWatcher.isLight()
        })
    },
    beforeUnmount() {
        // 移除监听器
        if (this.themeWatcher) {
            this.themeWatcher.unwatch()
        }
    },
    methods: {},
    components: {},
}
</script>
<style lang="less" scoped>
.cash-con {
    height: 100%;
}

/* 浅色模式 */
.light {
    --bgc-white: white;
    --bgc-black: #181818;
    --text-gray: #666;
    --button-text-color-white: #fff;
}

/* 深色模式 */
.dark {
    --bgc-white: #080808;
    --bgc-black: #f3f3f3;
    --text-gray: #d8d8d8;
    --button-text-color-white: #181818;
}
</style>
